import(/* webpackMode: "eager", webpackExports: ["ErrorToast"] */ "/opt/buildhome/repo/app/components/errortoast.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/opt/buildhome/repo/app/components/navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToastStack"] */ "/opt/buildhome/repo/app/components/toaststack.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoalsPopup"] */ "/opt/buildhome/repo/app/popups/goals.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductPopup"] */ "/opt/buildhome/repo/app/popups/product.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StoresLoader"] */ "/opt/buildhome/repo/app/stores/loader.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Geist\",\"arguments\":[{\"variable\":\"--font-geist-sans\",\"subsets\":[\"latin\"]}],\"variableName\":\"geistSans\"}");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Geist_Mono\",\"arguments\":[{\"variable\":\"--font-geist-mono\",\"subsets\":[\"latin\"]}],\"variableName\":\"geistMono\"}");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/globals.css");
